module.exports = __webpack_public_path__ + "static/media/curling.f6c03335.svg";